import { Button } from '@talentmesh/ui/components/button';
import { toast } from '@talentmesh/ui/components/sonner';
import { TypographyH2, TypographyP } from '@talentmesh/ui/components/typography';
import { LinkIcon } from 'lucide-react';
import React from 'react';
import ShareLink from '../components/ShareLink';
import Facebook from '../Icons/Facebook';
import Linkedin from '../Icons/Linkedin';
import Twitter from '../Icons/Twitter';
import { getFacebookShareLink, getTwitterShareLink, getLinkedinShareLink } from '../utils/ShareUtils';
import UIStrings from '../utils/UIStrings';

interface ShareCardProps {
    jobAdTitle: string;
}

function ShareCard({ jobAdTitle }: ShareCardProps): React.JSX.Element {
    function copyUrlToClipboard() {
        navigator.clipboard.writeText(window.location.href);
        toast(UIStrings.LinkHasBeenCopied);
    }

    return (
        <div className="flex flex-col gap-2">
            <TypographyH2 className="text-foreground font-bold">{UIStrings.ShareThisJob}</TypographyH2>
            <TypographyP className="text-foreground text-base">{UIStrings.ShareThisJobOnSocialOrCopyLink}</TypographyP>
            <div className="flex flex-row items-center gap-4">
                <ShareLink href={getFacebookShareLink()} icon={<Facebook />} />
                <ShareLink href={getLinkedinShareLink()} icon={<Linkedin />} />
                <ShareLink href={getTwitterShareLink(jobAdTitle)} icon={<Twitter />} />
                <Button type="button" variant="outline" size="sm" onClick={copyUrlToClipboard}>
                    <span className="flex w-full flex-row items-center gap-2">
                        <span className="text-foreground text-sm font-medium">{UIStrings.CopyLink}</span>
                        <LinkIcon data-icon="inline-end" />
                    </span>
                </Button>
            </div>
        </div>
    );
}

export default ShareCard;
